
// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getAnalytics } from "firebase/analytics";
import { getDataConnect } from 'firebase/data-connect';
import { connectorConfig } from "@dataconnect/generated";
import { getStorage, ref, getDownloadURL } from "firebase/storage";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
    // storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "zenokids-firebase",
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
    appId: process.env.REACT_APP_FIREBASE_APP_ID,
    measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET_GS
  };
  
// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);

export const provider = new GoogleAuthProvider();
// Add basic profile and email scopes (these are included by default)
provider.addScope('profile');
provider.addScope('email');
// Initialize services (dataConnect and analytics are initialized but not exported as they're used internally by Firebase)
getDataConnect(connectorConfig);
getAnalytics(app);
const storage = getStorage(app);
export const db = getFirestore(app);

export async function getDownloadUrlFromPath(storagePath) {
  if (!storagePath) return null;
  try {
    const r = ref(storage, storagePath); // supports 'folder/file', 'gs://', or storage https URL
    return await getDownloadURL(r);
  } catch (e) {

    return null;
  }
}